import { render, staticRenderFns } from "./BookMenuDropdown.vue?vue&type=template&id=6e4972ea&scoped=true&"
import script from "./BookMenuDropdown.vue?vue&type=script&lang=js&"
export * from "./BookMenuDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BookMenuDropdown.vue?vue&type=style&index=0&id=6e4972ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4972ea",
  null
  
)

export default component.exports